export function getGroupFolderKey(deviationId, { groupId, type, folderId }) {
    return `${deviationId}:${groupId}:${type}:${folderId}`;
}
export function getGroupsStreamId() {
    return 'groups';
}
export function getFolderStreamId(type, groupId) {
    return `folders:${groupId}:${type}`;
}
